// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"1cd00235","388":"0c2ecbf9","394":"6cf85624","426":"b002abd3","453":"19a30ac3","798":"4aa5a8a4","878":"d1ebace6","981":"192fb0a9"}[chunkId] + ".chunk.js";
};